import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterMessagePictoProps extends pictoProps {
}

export interface FooterMessagePictoState extends pictoState {
}

export class FooterMessagePicto extends Picto<FooterMessagePictoProps,FooterMessagePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerMessagesPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterMessagePicto);
